<template>
	<div style="padding: 16px; box-sizing: border-box;">
		<!-- 顶部标签栏与操作区 -->
		<div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
			<el-tabs v-model="activeName" @tab-click="handleTabClick" style="flex: 1;">
				<el-tab-pane :label="$t('电池.电池预热')" name="preheat"></el-tab-pane>
				<el-tab-pane :label="$t('电池.电池预冷')" name="precool"></el-tab-pane>
			</el-tabs>

			<div style="display: flex; align-items: center;">
				<span style="font-size: 12px;">{{ $t('time.timeQuery') }}</span>
				<el-date-picker v-model="dateRange" type="daterange" size="mini" :range-separator="$t('time.to')"
					value-format="yyyy-MM-dd" :start-placeholder="$t('time.startTimeHolder')"
					:end-placeholder="$t('tiem.endTimeHolder')" clearable style="width:265px" />
				<el-button style="margin-left: 30px;" type="primary" size="small"
					@click="handleQuery">{{ $t('public.query') }}</el-button>
				<el-button type="success" style="margin-left: 20px;" size="small" @click="handleAdd">
					{{ activeName === 'preheat' ? $t('电池.新增电池预热') : $t('电池.新增电池预冷') }}
				</el-button>
			</div>
		</div>
		<!-- 表格内容区 -->
		<div style="height: calc(100vh - 135px - 60px); overflow: auto; padding-right: 8px;">
			<!-- 预热/预冷表格统一逻辑（复用数据处理） -->
			<el-table :data="tableData" border style="width: 100%" max-height="500" v-loading="loading">
				<el-table-column align="center" type="index" :label="$t('public.index')" width="80" />
				<el-table-column align="center" prop="CarNo" :label="$t('vehicle.carNo')" />
				<el-table-column align="center" prop="type" :label="$t('recharge.频次')" />
				<el-table-column align="center" prop="BeginDate" :label="$t('public.date')" />
				<el-table-column align="center" prop="PreHeatTime" :label="$t('电池.用车时间')" />
				<el-table-column align="center" prop="PreHeatDuration" :label="$t('电池.时长')" />
				<el-table-column align="center" prop="operator" :label="$t('operlogq.OperatorName')" />
				<el-table-column align="center" :label="$t('public.Operation')" width="180">
					<template #default="scope">
						<el-button type="text" @click="handleViewRecord(scope.row)">
							{{ $t('电池.查看执行记录') }}</el-button>
						<!-- 取消预约按钮：新增时间对比判断禁用状态和文本 -->
						<el-button type="text" :text-color="isCancelable(scope.row) ? '#ff4d4f' : 'grey'"
							:disabled="!isCancelable(scope.row)"
							@click="isCancelable(scope.row) && handleCancel(scope.row)">{{
								getCancelButtonText(scope.row) }}</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页组件（预热/预冷共用） -->
			<div style="text-align: right; margin-top:8px" class="pagination" v-show="total > 0">
				<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
					:page-size="pageSize" layout="total, prev, pager, next" :total="total" />
			</div>
		</div>

		<!-- 执行记录弹窗（共用） -->
		<el-dialog :title="$t('电池.预约执行记录')" :visible.sync="dialogVisible" width="500px">
			<el-divider style="margin-top: 25px;"></el-divider>
			<div style="max-height: 400px; overflow: auto; margin-bottom: 20px;">
				<el-table :data="recordTableData" border style="width: 100%" v-loading="recordLoading">
					<el-table-column align="center" prop="TheDate" :label="$t('电池.执行日期')" />
					<el-table-column align="center" prop="PreHeatTime" :label="$t('电池.开启时间')" />
					<el-table-column align="center" prop="PreHeatDuration" :label="$t('电池.时长')" />
					<el-table-column align="center" :label="$t('电池.执行结果')">
						<template #default="scope">
							<span :style="{ color: getResultColor(scope.row.CurrentState) }">
								{{ getResultText(scope.row.CurrentState) }}
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>

		<!-- 新增弹窗（预热/预冷共用） -->
		<el-dialog :title="getDialogTitle()" :visible.sync="addDialogVisible"
			:width="LanguageId == 1 ? '750px' : '1050px'">
			<el-divider></el-divider>
			<div style="font-size: 14px;margin: 20px 20px;">{{ activeName === 'preheat' ? $t('电池.电池预热信息') :
				$t('电池.电池预冷信息') }}
			</div>

			<el-form :label-width="LanguageId == 1 ? '120px' : '270px'" ref="formRef" :model="formData"
				:rules="formRules">
				<div style="display: flex; align-items: center; justify-content: center; ">
					<div>
						<el-form-item :label="activeName === 'preheat' ? $t('电池.预热频次') : $t('电池.预冷频次')" prop="frequency">
							<el-select v-model="formData.frequency" :placeholder="$t('电池.请选择频次')"
								@change="handleFrequencyChange">
								<el-option v-for="item in frequencyOptions" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-form-item>
						<el-form-item :label="activeName === 'preheat' ? $t('电池.预热时长') : $t('电池.预冷时长')" prop="duration">
							<el-select v-model="formData.duration" :placeholder="$t('电池.请选择时长')">
								<el-option v-for="item in durationOptions" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</div>
					<div style="margin-right: 40px;overflow:inherit !important">
						<el-form-item :label="activeName === 'preheat' ? $t('电池.预热日期') : $t('电池.预冷日期')" prop="date">
							<!-- 单次：单个日期 / 每天：日期范围 -->
							<el-date-picker v-if="formData.frequency === $t('电池.单次')" v-model="formData.date"
								key="picker_day" :picker-options="pickerOptions" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd" type="date" :placeholder="$t('vehicleInfo.selectusedate')" />
							<el-date-picker v-else v-model="formData.date" type="daterange" format="yyyy-MM-dd"
								key="picker_month" :picker-options="pickerOptions" value-format="yyyy-MM-dd"
								:range-separator="$t('time.to')" :start-placeholder="$t('time.startTimeHolder')"
								:end-placeholder="$t('time.endTimeHolder')" />
						</el-form-item>
						<el-form-item :label="$t('电池.用车时间') + ':'" prop="useTime">
							<!-- 动态时间选择器：根据频次+日期调整规则 -->
							<el-time-select v-model="formData.useTime" :picker-options="timeSelectOptions"
								value-format="HH:mm:ss" :placeholder="$t('电池.请选择用车时间')" />
						</el-form-item>
					</div>
				</div>
				<div style="text-align: right;">
					<el-form-item>
						<el-button @click="addDialogVisible = false">{{ $t('public.cancel') }}</el-button>
						<el-button type="primary" @click="handleFormSubmit"
							:loading="submitLoading">{{ $t('public.save') }}</el-button>
					</el-form-item>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import {
	mapState
} from 'vuex';
import {
	controlEncrypt
} from '@/utils/encrypt';

import language from '@/utils/getLanguageId';
export default {
	name: 'BatteryControl',
	data() {
		// 1. 统一常量管理：避免硬编码
		this.SET_TYPE_MAP = {
			preheat: 1,
			precool: 2
		}; // 预热=1，预冷=2
		this.OPERATE_MAP = {
			add: 1,
			cancel: 3
		}; // 新增=1，取消=3

		return {
			activeName: 'preheat', // 当前标签（preheat=预热，precool=预冷
			dateRange: [
			this.	moment().subtract(6, 'days').format('YYYY-MM-DD'), // 默认最近一周（今天-6天）
				this.moment().format('YYYY-MM-DD')
			],
			tableData: [], // 表格数据
			recordTableData: [], // 执行记录数据
			total: 0, // 总条数
			currentPage: 1, // 当前页
			pageSize: 10, // 页大小
			loading: false, // 表格加载状态
			recordLoading: false, // 执行记录加载状态
			submitLoading: false, // 表单提交加载状态
			dialogVisible: false, // 执行记录弹窗
			addDialogVisible: false, // 新增弹窗
			pickerOptions: {
				disabledDate(date) {
					// 禁用今天之前的日期（只能选今天及以后）
					return date < this.moment().subtract(1, 'days').endOf('day');
				}
			},
			// 表单数据（预热/预冷共用）
			formData: {
				frequency: this.$t('ACSetting.每天'), // 频次：默认每天
				date: null, // 日期：单次=字符串，每天=数组[开始,结束]
				useTime: '', // 用车时间
				duration: '' // 时长（分钟）
			},
			// 下拉选项（统一管理）
			frequencyOptions: [{
				label: this.$t('电池.单次'),
				value: this.$t('电池.单次'),
			},
			{
				label: this.$t('ACSetting.每天'),
				value: this.$t('ACSetting.每天')
			}
			],
			durationOptions: [{
				label: '10min',
				value: '10'
			},
			{
				label: '20min',
				value: '20'
			},
			{
				label: '30min',
				value: '30'
			},
			{
				label: '60min',
				value: '60'
			},
			{
				label: '120min',
				value: '120'
			},
			{
				label: '150min',
				value: '150'
			},
			{
				label: '180min',
				value: '180'
			}
			],
			LanguageId: 1,
			// 表单验证规则（共用）
			formRules: {
				frequency: [{
					required: true,
					message: this.$t('电池.请选择频次'),
					trigger: 'change'
				}],
				date: [{
					required: true,
					message: this.$t('vehicleInfo.selectusedate'),
					trigger: 'change'
				}],
				useTime: [{
					required: true,
					message: this.$t('电池.请选择用车时间'),
					trigger: 'change'
				}],
				duration: [{
					required: true,
					message: this.$t('电池.请选择时长'),
					trigger: 'change'
				}]
			},
		};
	},
	computed: {
		...mapState({
			opened: state => state.app.sidebar.opened,
			selectedVehicles: state => state.app.vehicles.selectedVehicles,
			operator: state => state.app.operator // 直接映射操作人，避免重复获取
		}),
		// 获取选中的车辆ID（复用逻辑）
		selectedVehicleIds() {
			const vehicleIds = this.selectedVehicles
				.filter(item => item.treeLevel === 5)
				.map(item => item.nodeValue);
			return vehicleIds.join(',') || '';
		},
		selectedVehicleCount() {
			return this.selectedVehicles.filter(item => item.treeLevel === 5).length;
		},
		/**
		 * 动态时间选择器规则（核心修改）
		 * 根据「频次+日期」自动调整：
		 * 1. 单次+今天 → start=当前时间后1小时，可选范围=start~23:59
		 * 2. 单次+非今天 → start=00:00，可选范围=00:00~23:59
		 * 3. 每天 → start=00:00，可选范围=00:00~23:59
		 */
		timeSelectOptions() {
			const {
				frequency,
				date
			} = this.formData;
			let start = '00:00';
			let selectableRange = '00:00:00 - 23:59:59';

			// 场景1：单次 + 日期已选择 + 日期是今天
			if (frequency === this.$t('电池.单次') && date) {
				const isToday = this.moment(date).isSame(this.moment(), 'day');
				if (isToday) {
					// 计算当前时间后1小时（用moment处理跨天，如23:00+1h=00:00）
					start = this.moment().add(1, 'hours').format('HH:mm');
					// 可选范围：当前时间后1小时 ~ 23:59
					selectableRange = `${start}:00 - 23:59:59`;
				}
			}

			return {
				start, // 时间选择器默认的开始选项
				step: '00:01', // 分钟步长
				end: '23:59', // 固定结束时间
				selectableRange // 可选时间范围（限制用户只能选合法时间）
			};
		}
	},
	mounted() {
		this.LanguageId = language(this.$store.getters.locale)
		this.getTableData(); // 初始化加载表格数据
	},
	watch: {
		// 监听日期变化：更新用车时间默认值+清除验证
		'formData.date': function (newVal) {
			if (!newVal) return;
			this.$nextTick(() => {
				// 清除之前的时间验证状态
				if (this.$refs.formRef) this.$refs.formRef.clearValidate('useTime');
				// 自动填充符合规则的默认时间
				this.setDefaultUseTime();
			});
		}
	},
	methods: {
		isCancelable(row) {
			try {
				// 1. 先判断状态：必须是CurrentState=0
				if (row.CurrentState !== 0) return false;

				// 2. 拼接预约时间（BeginDate + PreHeatTime）
				const reserveTimeStr = `${row.BeginDate} ${row.PreHeatTime}`;
				// 用moment解析预约时间（指定格式避免歧义）
				const reserveTime = this.moment(reserveTimeStr, 'YYYY-MM-DD HH:mm');
				// 解析失败视为不可取消
				if (!reserveTime.isValid()) return false;

				// 3. 对比：预约时间 > 当前时间 → 可取消
				return reserveTime.isAfter(this.moment());
			} catch (error) {
				console.error(this.$t('电池.判断可取消状态失败'), error);
				return false; // 异常情况默认不可取消
			}
		},
		/**
		 * 核心方法：根据频次+日期设置默认用车时间
		 * 1. 单次+今天 → 默认当前时间后1小时
		 * 2. 单次+非今天/每天 → 默认00:00
		 */
		setDefaultUseTime() {
			const {
				frequency,
				date
			} = this.formData;
			if (!date) return;

			let defaultTime = '00:00:00'; // 默认00:00
			if (frequency === this.$t('电池.单次') && this.moment(date).isSame(this.moment(), 'day')) {
				// 单次+今天：默认当前时间后1小时（格式HH:mm:ss）
				defaultTime = this.moment().add(1, 'hours').format('HH:mm:ss');
			}

			// 更新表单默认值（避免覆盖用户已选值）
			if (!this.formData.useTime) {
				this.formData.useTime = defaultTime;
			}
		},
		getCancelButtonText(row) {
			// 先判断时间：若预约时间早于当前 → 直接显示“不可取消”
			const reserveTimeStr = `${row.BeginDate} ${row.PreHeatTime}`;
			const reserveTime = this.moment(reserveTimeStr, 'YYYY-MM-DD HH:mm');
			if (reserveTime.isValid() && reserveTime.isBefore(this.moment())) {
				return this.$t('电池.不可取消');
			}

			// 时间符合要求：再按CurrentState显示
			switch (row.CurrentState) {
				case 0:
					return this.$t('电池.取消预约');
				case 1:
					return this.$t('电池.不可取消');
				case 2:
					return this.$t('电池.不可取消');
				case 3:
					return this.$t('电池.不可取消');
				case 4:
					return this.$t('public.已取消');
				default:
					return this.$t('电池.不可取消');
			}
		},

		// 2. 复用逻辑：获取表格数据（预热/预冷共用）
		getTableData() {
			// 校验逻辑：未选择车辆或选择多辆车时提示
			if (this.selectedVehicleCount > 1) {
				this.$message.warning(this.$t('电池.只能选择一辆'));
				return;
			}

			this.loading = true;
			// 格式化日期参数
			const params = {
				V_ID: this.selectedVehicleIds,
				pageNo: this.currentPage,
				pageSize: this.pageSize,
				SetType: this.SET_TYPE_MAP[this.activeName],
				BeginDate: this.dateRange[0].substring(0, 10),
				EndDate: this.dateRange[1].substring(0, 10),
			};

			this.$api.queryPreHeatSettingInfo(params).then(res => {
				this.loading = false;
				if (res.code === 200 && res.data.length > 0) {
					this.tableData = res.data.map(item => ({
						...item,
						// 统一处理"频次"字段（单次/每天）
						type: item.BeginDate === item.EndDate ? this.$t('电池.单次') : this.$t('ACSetting.每天'),
						// 统一处理"操作人"字段
						operator: this.$store.getters.operator.OpeName || this.$t('public.unKnown')
					}));
					this.total = res.count;
				} else {
					this.tableData = [];
					this.total = 0;
					// this.$message.error('数据加载失败');
				}
			}).catch(err => {
				this.loading = false;
				this.$message.error(this.$t('路费.接口请求失败'));
				console.error(err);
			});
		},

		// 3. 复用逻辑：获取加密参数（新增/取消共用）
		getEncryptedParams(reservationText) {
			try {
				const encryptResult = controlEncrypt(reservationText);
				return {
					ciphertextAES: encryptResult.ciphertextAES,
					ciphertextPara: encryptResult.encryptedPara,
					flagD: encryptResult.flagD
				};
			} catch (error) {
				this.$message.error(this.$t('电池.数据加密失败'));
				console.error(this.$t('电池.加密错误'), error);
				return null;
			}
		},

		// 4. 动态获取弹窗标题
		getDialogTitle() {
			return this.activeName === 'preheat' ? this.$t('电池.新增电池预热') :
				this.$t('电池.新增电池预冷');
		},

		// 5. 切换频次时：重置日期+设置默认时间
		handleFrequencyChange(value) {
			// 清空日期和时间选择
			this.formData.date = null;
			this.formData.useTime = '';
			// 清除验证状态
			if (this.$refs.formRef) {
				this.$refs.formRef.clearValidate(['date', 'useTime']);
			}

			// 给日期设置默认值
			this.$nextTick(() => {
				if (value === this.$t('电池.单次')) {
					// 单次默认今天
					this.formData.date = this.moment().format('YYYY-MM-DD');
				} else if (value === this.$t('ACSetting.每天')) {
					// 每天默认今天~今天+6天（一周）
					this.formData.date = [
						this.moment().format('YYYY-MM-DD'),
						this.moment().add(6, 'days').format('YYYY-MM-DD')
					];
				}
				// 同步设置默认用车时间
				this.setDefaultUseTime();
			});
		},

		// 6. 表单提交：新增预约（预热/预冷共用）
		handleFormSubmit() {
			this.$refs.formRef.validate(valid => {
				if (!valid) return;

				// 处理日期参数（单次=开始=结束，每天=范围拆分）
				const [BeginDate, EndDate] = this.formData.frequency === this.$t('电池.单次') ? [this.formData.date, this
					.formData.date
				] : [this.formData.date[0], this.formData.date[1]];

				// 构造请求参数
				const reservationText = {
					SetID: 0, // 新增时SetID为0
					V_ID: this.selectedVehicleIds,
					BeginDate,
					EndDate,
					PreHeatTime: this.formData.useTime,
					PreHeatDuration: this.formData.duration,
					operate: this.OPERATE_MAP.add, // 新增=1
					SetType: this.SET_TYPE_MAP[this.activeName], // 动态SetType
					AppFlag: 2 // web端固定为2
				};

				// 获取加密参数
				const encryptedParams = this.getEncryptedParams(reservationText);
				if (!encryptedParams) return;

				this.submitLoading = true;
				this.$api.savePreHeatSettingInfo(encryptedParams).then(res => {
					this.submitLoading = false;
					if (res.code === 200) {
						this.$message.success(this.$t('路费.新增成功'));
						this.addDialogVisible = false;
						this.getTableData(); // 刷新表格
						this.resetForm(); // 重置表单
					} else {
						this.$message.error(this.$t('路费.新增失败'));
					}
				}).catch(err => {
					this.submitLoading = false;
					this.$message.error(this.$t('路费.接口请求失败'));
					console.error(err);
				});
			});
		},

		// 7. 取消预约：预热/预冷共用
		handleCancel(row) {
			this.$confirm(this.$t('电池.确定取消该预约'), this.$t('电池.取消预约'), {
				confirmButtonText: this.$t('public.confirm'),
				cancelButtonText: this.$t('public.cancel'),
				type: 'warning'
			}).then(() => {
				// 构造取消请求参数（复用row中的SetType）
				const reservationText = {
					SetID: row.SetID,
					V_ID: this.selectedVehicleIds,
					BeginDate: row.BeginDate,
					EndDate: row.EndDate,
					PreHeatTime: row.PreHeatTime,
					PreHeatDuration: row.PreHeatDuration,
					operate: this.OPERATE_MAP.cancel, // 取消=3
					SetType: row.SetType, // 用行数据中的SetType，避免标签切换影响
					AppFlag: 2
				};

				// 获取加密参数
				const encryptedParams = this.getEncryptedParams(reservationText);
				if (!encryptedParams) return;

				this.loading = true;
				this.$api.savePreHeatSettingInfo(encryptedParams).then(res => {
					this.loading = false;
					if (res.code === 200) {
						this.$message.success(this.$t('public.cancelSuccess'));
						this.getTableData(); // 刷新表格
					} else {
						this.$message.error(this.$t('电池.取消失败'));
					}
				}).catch(err => {
					this.loading = false;
					this.$message.error(this.$t('路费.接口请求失败'));
					console.error(err);
				});
			}).catch(() => {
				// 取消确认时不做操作
			});
		},

		// 8. 查看执行记录（共用）
		handleViewRecord(row) {
			this.dialogVisible = true;
			this.recordLoading = true;
			this.$api.queryPreHeatSettingDetail({
				SetID: row.SetID
			}).then(res => {
				this.recordLoading = false;
				if (res.code === 200) {
					this.recordTableData = res.data;
				} else {
					this.recordTableData = [];
					this.$message.error(this.$t('电池.执行记录加载失败'));
				}
			}).catch(err => {
				this.recordLoading = false;
				this.$message.error(this.$t('路费.接口请求失败'));
				console.error(err);
			});
		},

		// 9. 辅助方法：执行结果颜色
		getResultColor(status) {
			const colorMap = {
				0: 'grey',
				1: 'orange',
				2: 'green',
				3: 'red'
			};
			return colorMap[status] || '';
		},

		// 10. 辅助方法：执行结果文本
		getResultText(status) {
			const textMap = {
				0: this.$t('电池.未下发'),
				1: this.$t('电池.待执行'),
				2: this.$t('电池.已执行'),
				3: this.$t('执行失败'),
			};
			return textMap[status] || this.$t('电池.未知状态');
		},

		// 11. 辅助方法：重置表单
		resetForm() {
			this.formData = {
				frequency: this.$t('ACSetting.每天'),
				date: null,
				useTime: '',
				duration: ''
			};
			if (this.$refs.formRef) this.$refs.formRef.resetFields();
		},

		// 标签切换事件
		handleTabClick() {
			this.currentPage = 1; // 切换标签重置页码
			this.getTableData(); // 加载对应标签的表格数据
		},

		// 查询事件
		handleQuery() {
			this.currentPage = 1;
			if (this.selectedVehicleCount === 0) {
				this.$message.warning(this.$t('电池.请先选择一辆车'));
				return;
			}
			if (this.selectedVehicleCount > 1) {
				this.$message.warning(this.$t('电池.只能选择一辆'));
				return;
			}

			this.getTableData();
		},

		// 分页切换事件
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getTableData();
		},

		// 打开新增弹窗：初始化默认值
		handleAdd() {
			if (this.selectedVehicleCount === 0) {
				this.$message.warning(this.$t('电池.请先选择一辆车'));
				return;
			}
			if (this.selectedVehicleCount > 1) {
				this.$message.warning(this.$t('电池.只能选择一辆'));
				return;
			}

			this.addDialogVisible = true;
			this.$nextTick(() => {
				this.resetForm();
				// 初始化日期默认值（每天=今天~今天+6天，单次=今天）
				if (this.formData.frequency === this.$t('ACSetting.每天')) {
					this.formData.date = [
						this.moment().format('YYYY-MM-DD'),
						this.moment().add(6, 'days').format('YYYY-MM-DD')
					];
				} else {
					this.formData.date = this.moment().format('YYYY-MM-DD');
				}
				// 初始化默认用车时间
				this.setDefaultUseTime();
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.el-tabs__header {
	margin-bottom: 0; // 去掉标签页默认下边距
}

.el-dialog__body {
	padding: 16px !important;
	padding-bottom: 128px !important;
}

/* 执行记录表格样式 */
.record-table {
	max-height: 400px;
	overflow: auto;
	font-size: 14px;
}

/* 统一输入框宽度 */

::v-deep .el-input__inner {
	width: 257px !important;
}

::v-deep .el-date-editor .el-range-separator {
	width: 23% !important;
}

/* 时间选择器选项宽度适配 */
::v-deep .el-time-select__content {
	width: auto !important;
	min-width: 240px;
}
</style>